
  <button (click)="handleClick()" class="primary-btn {{className}}">
    {{text}}
  </button>
